import(/* webpackMode: "eager" */ "/root/services/fash-creative/src/app/faqs/page.tsx")